module.exports = __webpack_public_path__ + "4e26b5aaa33c31629dddfc45177faf2d.pdf";